<template>

  <g v-on:click.stop="click" style="cursor:pointer" :style=master_style>

    <g v-for="subnode,id in node.children">
      <rect :x=xpos :y="(yposes[subnode.index]*value_scale + ypos)*global_scale_y" :width=width*global_scale_x :height=heights[subnode.index]*$store.state.global_scale_y :style=rect_style(id) />
      <template v-if="squash">
      <line :x1=xpos :y1="(yposes[subnode.index]*value_scale + ypos)*global_scale_y" :x2=xpos+width*global_scale_x :y2="(yposes[subnode.index]*value_scale + ypos)*global_scale_y" :stroke="c2" stroke-width=.5 />
      <line :x1=xpos :y1="(yposes[subnode.index]*value_scale + ypos)*global_scale_y + heights[subnode.index]*$store.state.global_scale_y" :x2=xpos+width*global_scale_x :y2="(yposes[subnode.index]*value_scale + ypos)*global_scale_y + heights[subnode.index]*$store.state.global_scale_y" :stroke="c2" stroke-width=.5 />
      </template>
    </g>
    <text filter="url(#textbg)" class="noselect" :x="xpos+(width+5)*global_scale_x" :y="(ypos + node.scaled_value($store.state))*global_scale_y" :style=font_style>{{label}}</text>
  </g>
</template>

<script>



import { mapGetters, mapState } from 'vuex'

import * as d3 from 'd3'

import utils from '../utils'


import mecs from '../assets/mecs_naics.js'

export default {
  name: 'DataNode',
  props: ['node','groupid','columnid'],
  components: {},
  mounted(){
  },
  computed: {
    ...mapState(['value_scale','global_scale_x','global_scale_y','node_thickness','column_separation','palettes','color_type','up_down','search_term','cur_node','tool','stroke_width','loss_color','energy_services_color','mousepos','sigfig','squash']),
    ...mapGetters(['node_color']),
    srcSum(){
      return d3.sum(Object.values(this.node.source_amts))
    },
    label(){
      if (this.node.children.length>1 && this.node.children.map(n=>n.naics_code!=null).reduce((acc,v)=> acc && v,true)){
        var three = this.node.children[0].naics_code.toString().slice(0,3)
        return "NAICS " + three + " : " + mecs.rev_codes[three] + " ..."
        }
      return this.display_name() + " : " + this.node.get_value().toFixed(this.sigfig)
    },
    text_background_style(){
      return {"fill":"white","opacity":".85"}
    },
    master_style(){
      return {
        'opacity':(this.irrelevant? .1 : 1)
      }
    },
    width(){
      return this.node_thickness + (this.node.children.reduce( (acc,cur)=>acc|=cur.is_reserves,false) ? 40 : 0)
    },
    heights() {
      return this.node.scaled_heights(this.value_scale)
    },
    xpos() {
      return this.column_separation*this.node.column*this.global_scale_x
    },
    yposes() {
      return this.node.relative_y_positions()
    },
    bump(){

      var ydist = this.node.y_position*this.global_scale_y-this.mousepos.y
      var xdist = this.xpos-this.mousepos.x
      if(xdist > 100) return 0
      var dist= xdist*xdist + ydist*ydist

      var bump = 0
      var limit=150000
      if(dist < limit){
        bump = 1./Math.max(dist,1e-8)
      }
      return bump
    },
    ypos(){
      return this.node.y_position
    },
    top() {
      return this.node.y_position*this.global_scale_y
    },
    font_style(){
      return {"font-size": (Math.max(Math.min(this.node.get_value()*.7,18),15) + (this.is_current?10:0)),
              "font-weight": this.is_current?"bold":"normal"
             }
    },
    color(){
      if(this.node.name.includes('*energy services*'))
        return d3.color(this.energy_services_color)

      var lossy=this.node.source_links.reduce( (acc,cur)=>{return acc||cur.is_loss},false  )
      lossy&=this.node.target_links.reduce( (acc,cur)=>{return acc||cur.is_loss},false  )
      if(this.node.name.includes('*waste*') || lossy)
        return d3.color(this.loss_color)
      return this.node_color(this.node)
    },
    c2(){
      return d3.hsl(this.color).darker(2)
    },
    source(){
      return this.node.datasource()[0]
    },
    is_current(){
      return (this.cur_node && this.cur_node == this.node)
    },
    in_upstream(){
      var c = this.up_down
      if(!c) return true
      var found = false
      this.node.children.forEach( n=>{
        found|=n.is_updown
      })
      return found
    },
    in_downstream(){
      var c = this.up_down
      if(!c) return true
      var found = false
      this.node.children.forEach( n=>{
        found|=n.is_updown
      })
      return found
    },
    is_searched(){
      return this.node.is_searched && !(this.node.name.includes("*waste") || this.node.name.includes("*energy"))
    },
    irrelevant(){
      if (this.up_down){
        return !(this.in_upstream || this.in_downstream)
      }

      return this.search_term.length && !this.is_searched
    },
    naics_code(){
      if (this.source == 'CBECS')
        return "(no NAICS)"
      if (this.node.name in mecs.codes)
        return "NAICS CODE " + mecs.codes[this.node.name]
      return null
    }
  },
  methods: {
    rect_style(id){
      var c= d3.hsl(this.color)
      var c2 = d3.hsl(c)
      var group_selected = false //this.$store.state.currentNodes[this.node.index]
      if (!group_selected){
        c.l=.98
        c.s=.1
      }else{
        c.l=.8
      }
      c2=c2.darker(1.25)

      if (id%2)
        c2=c2.darker(1.3)
      var sw = this.is_current ? 2 : this.stroke_width

      return {
        'stroke-width':  sw,
        'stroke': this.is_current ? d3.rgb(246,196,68) : c2,
        'fill':c2
      }
    },
    display_name(){
      var n = this.node.name
      if(n.length > 40)
        n=n.slice(0,40)+"..."
      if(n.includes("*waste*")) return "waste"
      if(n.includes("*energy services*")) return "energy services"
      else if (n.includes("overhead")) return "overhead"
      else return n
    },
    click_updown(){
      if(this.up_down == this.node)
        this.$store.commit("setUpDown",null)
      else
        this.$store.commit("setUpDown",this.node)
    },
    click_info(){
      if(this.is_current)
        this.$store.commit("setCurrentNode",null)
      else
        this.$store.commit("setCurrentNode",this.node)
    },
    click(){
      this.click_updown()
      this.click_info()
    },
    set_up_down(e){
      var t = this.tool
      if (t=="upstream/downstream"){
        /*
        if(this.$store.state.cur_node == this.node)
          this.$store.commit("setCurrentNode",null)
        else
          this.$store.commit("setCurrentNode",this.node)
*/
      }else if(t=="group"){
        this.$store.commit("nodeclick",this.node)
      }
      else if (t=="copy"){
        this.$store.dispatch("copyNode",this.node.children[0])
      }
      else if (t=="scale"){
        this.$store.commit("scaleNode",this.node.children[0])
      }
    },

  }
}
</script>

<style scoped>



.breakdown {
    font-style: italic;
    font-size:8pt;
}

.selected {
background-color:red;
margin-bottom:5px;
}


.hilite{
color:green;
text-decoration:underline;
}

.dehilite{
}

.standard{
    padding:4px;
}

.irrelevant{
  opacity:.1
}


.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}

</style>



// WEBPACK FOOTER //
// src/components/DataNode.vue